export default "__VITE_ASSET__CaZAIWrG__"